<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <!-- Role Management -->
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Role Management</h2>
          </div>
          <!-- Role Management List -->
          <div class="body pt-0">
            <div class="chart-top-action d-md-flex justify-content-end">
              <!-- Add new user Buttons -->
              <div class="mb-2">
                <b-button
                  variant="primary"
                  size="lg"
                  class="btn-mw"
                  @click="
                    $router.push({ path: '/user-managment/roles/create' })
                  "
                >
                  Add Role
                  <i class="fa fa-plus-square ml-1"></i>
                </b-button>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Table -->
            <b-table
              responsive
              outlined
              table-class="mb-0 table-custom"
              head-variant="light"
              :items="userRoles"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(action)>
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item
                    @click="
                      $router.push({ path: '/user-managment/roles/edit' })
                    "
                  >
                    Edit
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <template #cell(permissions)="data">
                <ul v-for="(module, index) in data.value" :key="index">
                  <li class="mb-0 font-14">
                    {{ module.name }}:
                    <span
                      :class="`badge ml-0 badge-${data == 'write' ? 'warning' : data == 'delete' ? 'danger' : 'success'}`"
                      v-for="(data, index) in module.permission"
                      :key="index"
                    >
                      {{ data.toUpperCase() }}
                    </span>
                  </li>
                </ul>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 d-flex align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RoleListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  data() {
    return {
      isVisibleFilter: false,
      userRoles: [
        {
          name: "ADMIN",
          permissions: [
            {
              name: "Dashboard",
              permission: ["read", "write", "delete"],
            },
            {
              name: "Listing",
              permission: ["read", "write", "delete"],
            },
            {
              name: "Transaction list",
              permission: ["read", "write", "delete"],
            },
            {
              name: "Customer",
              permission: ["read", "write", "delete"],
            },
            {
              name: "Partner",
              permission: ["read", "write", "delete"],
            },
          ],
        },
        {
          name: "USER",
          permissions: [
            {
              name: "Dashboard",
              permission: ["read"],
            },
            {
              name: "Listing",
              permission: ["read"],
            },
            {
              name: "Transaction list",
              permission: ["read"],
            },
            {
              name: "Customer",
              permission: ["read"],
            },
            {
              name: "Partner",
              permission: ["read"],
            },
          ],
        },
        {
          name: "MANAGER",
          permissions: [
            {
              name: "Dashboard",
              permission: ["read", "write"],
            },
            {
              name: "Listing",
              permission: ["read", "write"],
            },
            {
              name: "Transaction list",
              permission: ["read", "write"],
            },
            {
              name: "Customer",
              permission: ["read", "write"],
            },
            {
              name: "Partner",
              permission: ["read", "write"],
            },
          ],
        },
        {
          name: "OWNER",
          permissions: [
            {
              name: "Dashboard",
              permission: ["read", "delete"],
            },
            {
              name: "Listing",
              permission: ["read", "delete"],
            },
            {
              name: "Transaction list",
              permission: ["read", "delete"],
            },
            {
              name: "Customer",
              permission: ["read", "delete"],
            },
            {
              name: "Partner",
              permission: ["read", "delete"],
            },
          ],
        },
      ],
      role: {
        name: "User",
      },
      all_Permissions: [],
      role_permission: "",
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
          thClass: "user-name-img th_sortfix",
        },
        {
          key: "permissions",
          label: "Permissions",
          sortable: true,
          thClass: "role-badge th_sortfix",
        },
        { key: "action", label: "Action", thClass: "access-badge th_sortfix" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>
